import { useTranslation } from 'module/hooks/use-translation';
import { Form } from 'module/ui/components/atoms/form';
import { Input } from 'module/ui/components/atoms/input/input';
import { OutsideClickHandler } from 'module/ui/components/atoms/outside-click-handler';
import { InputRef } from 'antd';
import { FC, useRef, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { StopClickEventPropagation } from 'components/organisms/signal/detail/stop-click-event-propagration';
import { useAutomationContext } from './automation-context';

const FormItem = styled(Form.Item)`
  margin-bottom: 0;
  width: 100%;
`;

export const AutomationNameBlock: FC = () => {
  const placeholderText = useTranslation(
    'settings.salesforce.automation.name.placeholder',
  );
  const { automationDetails, setAutomationDetails } = useAutomationContext();
  const { automationName = '' } = automationDetails || {};

  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const [isAutomationNameCollapsed, setIsAutomationNameCollapsed] =
    useState(true);

  // Sync form values when automationName changes (for edit mode)
  useEffect(() => {
    form.setFieldsValue({ automationName });
  }, [automationName, form]);

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsAutomationNameCollapsed(true);
      }}
    >
      <BlockList.CollapsibleItem
        collasped={isAutomationNameCollapsed}
        onCollapseChange={(collapsed) => {
          setIsAutomationNameCollapsed(collapsed);

          return true;
        }}
      >
        <BlockList.CollapsibleItem.Label data-required="true">
          <BlockList.CollapsibleItem.Label.Text data-required="true">
            <FormattedMessage id="settings.integrations.create.automation.name.label" />
          </BlockList.CollapsibleItem.Label.Text>
        </BlockList.CollapsibleItem.Label>
        <BlockList.CollapsibleItem.Content>
          <div className="short-01">{automationName}</div>
        </BlockList.CollapsibleItem.Content>
        <BlockList.CollapsibleItem.ExpandedContent>
          <StopClickEventPropagation>
            <Form form={form}>
              <FormItem name={'automationName'} required>
                <Input
                  placeholder={placeholderText}
                  ref={inputRef}
                  value={automationName}
                  onChange={(e) =>
                    setAutomationDetails({
                      automationName: e.target.value,
                    })
                  }
                />
              </FormItem>
            </Form>
          </StopClickEventPropagation>
        </BlockList.CollapsibleItem.ExpandedContent>
      </BlockList.CollapsibleItem>
    </OutsideClickHandler>
  );
};
